export const SECTION = {
    INBOX: "INBOX",
    STARRED: "STARRED",
    TRASHED: "TRASHED",
};

export const SECTIONS_CONFIG = [
    { id: SECTION.INBOX, icon: "inbox" },
    { id: SECTION.STARRED, icon: "star", iconColor: "yellow" },
    { id: SECTION.TRASHED, icon: "trash" },
];

export const THREAD_STATE = {
    INBOX: "INBOX",
    ARCHIVED: "ARCHIVED",
    TRASHED: "TRASHED",
    DELETED: "DELETED",
};

export const THREAD_STATE_ACTIONS = {
    STAR: "star",
    UNSTAR: "unstar",
    READ: "read",
    UNREAD: "unread",
    TRASH: "trash",
    RESTORE: "restore",
    ARCHIVE: "archive",
}
export const THREAD_STATE_ACTIONS_GROUPS = {
    AFFECT_UNREAD_COUNT: [
        THREAD_STATE_ACTIONS.READ,
        THREAD_STATE_ACTIONS.UNREAD,
    ],
};

export const THREAD_LIFECYCLE = {
    ACTIVE: "ACTIVE",
    CLOSED: "CLOSED",
    DELETED: "DELETED",
};

export const MESSAGE_STATUS = {
    SENT: "SENT",
    PENDING: "PENDING",
};

export const TABLET_MAX_WIDTH_QUERY = "(max-width: 1199px)";
export const TABLET_MAX_WIDTH = "1199";
export const MOBILE_MAX_WIDTH_QUERY = "(max-width: 500px)";
export const MOBILE_MAX_WITDH = "500";

export const  MAX_MESSAGE_LENGTH = 500;


// WEBPACK FOOTER //
// ./src/features/messaging/constants.js